import { Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PoLookupFilter, PoLookupFilteredItemsParams } from '@po-ui/ng-components';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { UrlServerApiUtils } from 'src/utils/server-api-utils';

@Injectable()
export class LookupService implements PoLookupFilter {

  constructor(private httpClient: HttpClient, private contextApplication: ContextApplication) { }

  public IsSearching = false;

  private urlWithText = '';
  serverApiUtils = new UrlServerApiUtils(this.contextApplication);

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    this.urlWithText = this.getUrlApiTask();
    if (filteredParams.filter) {
      this.urlWithText += `&$filter=startswith(name ,'${filteredParams.filter}') or startswith(taskcode ,'${filteredParams.filter}') or startswith(description ,'${filteredParams.filter}')`;
    }
    const { page, pageSize } = filteredParams;
    const parameters = {page: page.toString(), pageSize: pageSize.toString() };
    return  this.httpClient.get(this.urlWithText, { params: parameters, headers: this.serverApiUtils.getHeaderOptions()});
  }

  getObjectByValue(value: string): Observable<any> {
    this.IsSearching = true;
    this.urlWithText = this.getUrlApiTask();
    if (value) {
      this.urlWithText += `&$filter=startswith(name ,'${value}') or startswith(taskcode ,'${value}') or startswith(description ,'${value}')`;
    }
    return this.httpClient.get(this.urlWithText, { headers: this.serverApiUtils.getHeaderOptions() });
  }

  getUrlApiTask(): string {
    return this.contextApplication.Server.apiServer + '/api/construction-projects/v1/activity-tasks?' + this.contextApplication.Filter;
  }
}
